module.exports = __webpack_public_path__ + "img/13-edit-input.c05c1644.svg";